import * as React from 'react'
import { PageLoader } from 'uiComponents/loaders'
import { FieldType } from 'uiComponents/studio/form/fieldComponentSchema'
import { BlacklistUrlSection } from 'engageTools/studio/form/blacklistUrlSection'
import { ConfigurationUnit } from 'uiComponents/studio/menuItem'
import { getConfigValue, handleInputChange } from 'engageTools/studio/shared'
import {
    TriggerButtonConfiguration,
    UrlRules,
    Languages,
    Translation,
    OnChangeFunc,
    SetConfigValueFunc,
} from 'engageTools/studio/schema'
import { ComponentsService } from 'engageTools/studio/componentsService'
import { GeneralSection } from './generalSection'
import LanguagesSection from './languagesSection'
import { ImagesService } from 'http/imagesService'
import { MessageKind } from 'uiComponents/messages'
import { FrequencyLimitSection } from './frequencyLimitSection'
import AudienceMarketing from '../form/fields/audienceMarketing'

interface FormProps {
    accountSlug: string
    section: ConfigurationUnit
    triggerButtonConfiguration: TriggerButtonConfiguration
    updateConfiguration: (path: string, value: string | number | boolean | string[]) => void
    componentsService: ComponentsService
    imagesService: ImagesService
    urlRules: UrlRules | null
    updateUrlRules: (list: string, logic: string, ruleType: string, value: string) => void
    languages: Languages | null
    translations: Translation[]
    updateTranslations: (slug: string, language: string, value: string) => void
    onLanguageChange: (selected: string[], primary: string) => void
    resetATranslation: (slug: string) => void
    translationsValidation: boolean
    setTranslationsValidation: (on: boolean) => void
    replaceTopMessages: (id: string, status: MessageKind, text: string) => void
    removeAllMessages: () => void
    translationsLoading: boolean
    setActiveLanguage: (v: string) => void
    activeLanguage: string
}

export function TriggerButtonForm(props: FormProps) {
    const onInputChange: OnChangeFunc = (
        value: React.ChangeEvent<HTMLInputElement> | string | boolean,
        path: string,
    ) => {
        handleInputChange(value, path, setConfigValue)
    }

    const setConfigValue: SetConfigValueFunc = (path: string, value: boolean | string | number) => {
        if (path) {
            props.updateConfiguration(path, value)
        }
    }

    if (!props.triggerButtonConfiguration || props.translationsLoading) {
        return <PageLoader />
    } else {
        const { section } = props
        if (section.name === 'Languages' && props.languages) {
            return (
                <LanguagesSection
                    accountSlug={props.accountSlug}
                    section={section}
                    getConfigValue={(item: FieldType) => getConfigValue(item, props.triggerButtonConfiguration)}
                    handleInputChange={onInputChange}
                    languages={props.languages}
                    updateLanguages={props.onLanguageChange}
                    configuration={props.triggerButtonConfiguration}
                    translations={props.translations}
                    updateConfiguration={props.updateConfiguration}
                    updateTranslations={props.updateTranslations}
                    resetATranslation={props.resetATranslation}
                    translationsValidation={props.translationsValidation}
                    setTranslationsValidation={props.setTranslationsValidation}
                    activeLanguage={props.activeLanguage}
                    setActiveLanguage={props.setActiveLanguage}
                />
            )
        } else if (section.name === 'Frequency limit') {
            return (
                <FrequencyLimitSection
                    section={section}
                    configuration={props.triggerButtonConfiguration}
                    updateConfiguration={props.updateConfiguration}
                />
            )
        } else if (section.name === 'Blacklist') {
            return (
                <BlacklistUrlSection
                    product="trigger_button"
                    section={section}
                    urlRules={props.urlRules}
                    updateUrlRules={props.updateUrlRules}
                />
            )
        } else if (section.name === 'Audience') {
            return <AudienceMarketing />
        } else {
            return (
                <GeneralSection
                    section={section}
                    configuration={props.triggerButtonConfiguration}
                    getConfigValue={(item: FieldType) => getConfigValue(item, props.triggerButtonConfiguration)}
                    handleInputChange={onInputChange}
                    componentsService={props.componentsService}
                    imagesService={props.imagesService}
                    replaceTopMessages={props.replaceTopMessages}
                    removeAllMessages={props.removeAllMessages}
                />
            )
        }
    }
}
